import React, { useState } from "react";
import { DropdownData } from '../../components/AccountManagement/DropdownData';
import '../../components/AccountManagement/Accounts.css';
import inputStyles from '../ManagementPages.module.css';
import { customStyles } from "../../components/AccountManagement/CustomStyles";
import Select from 'react-select';
import { useSelector } from 'react-redux';

const ActivatePersonalInfo = ({userData, handleChange}) => {
    
    const role = userData.role.name;
    const dropdowns = useSelector((state) => state.dropdowns);

    const [unitType, setUnitType] = useState(userData.preferences.unitType);
    const handleUnitChange = (e) => {
        setUnitType(e.target.value);
        handleChange(e,null,"preferences");
    };

    const [displayPhoneCountryCode, setDisplayPhoneCountryCode] = useState(() => {
        const countryCodeMatch = dropdowns.countries.find((code)=>code.phoneCountryCode === userData.countryCode)
        if (countryCodeMatch && userData.countryCode !== "") {
            return {value: countryCodeMatch.phoneCountryCode, label: `${countryCodeMatch.phoneCountryCode} (${countryCodeMatch.name})`}
        } else return {value:'', label: ''}
    });

    const [displayCountry, setDisplayCountry] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === userData.address.country);
        return selectedCountry ? { value: selectedCountry.code, label: selectedCountry.name } : { value: '', label: '' };
    });
    
    const [displayState, setDisplayState] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === userData.address.country);
        const selectedState = selectedCountry?.states.find(state => state.code === userData.address.state);
        return selectedState ? { value: selectedState.code, label: selectedState.name } : { value: '', label: '' };
    });

    const handlePhoneCountryCode = (selected) => {
        handleChange({value: selected.value},'countryCode');
        setDisplayPhoneCountryCode(selected);
    };

    const handleCountry = (selected) => {
        handleChange({value: selected.value},'country', 'address');
        handleChange({value: ''},'state', 'address');
        setDisplayState({ value: '', label: '' })
        setDisplayCountry(selected);
    };

    const handleState = (selected) => {
        handleChange({value: selected.value},'state', 'address');
        setDisplayState(selected);
    };

    return (
        <div style={{display: "flex", flexDirection:"column", gap:"10px"}}>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="firstName"
                        value={userData.firstName}
                        onChange={handleChange}
                        style={{width:"300px"}}
                    ></input>
                    <label className={userData.firstName && inputStyles['filled']}>
                        First Name
                    </label>
                </div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="lastName"
                        value={userData.lastName} 
                        onChange={handleChange}
                        style={{width:"300px"}}
                    ></input>
                    <label className={userData.lastName && inputStyles['filled']}>
                        Last Name
                    </label>
                </div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="email"
                        style={{width:"300px"}}
                        value={userData.email}
                        onChange={handleChange}
                    ></input>
                    <label className={userData.email && inputStyles['filled']}>
                        Email
                    </label>
                </div>
                <div style={{display:"flex",width: "300px",justifyContent:"space-between", height:"44px"}}>
                    <div style={{position: "relative", width: "40%"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>Country Code*</span>
                        <Select
                            options={dropdowns.countries.map((code) => {
                                return ({
                                    label: `${code.phoneCountryCode} (${code.name})`,
                                    value: code.phoneCountryCode
                                })
                            })}
                            styles={{
                                ...customStyles.popup,
                                container: (provided) => ({
                                    ...provided,
                                    width: '100%',
                                }),
                            }}
                            value={displayPhoneCountryCode}
                            placeholder='Code*'
                            isSearchable={true}
                            onChange={handlePhoneCountryCode}
                        />
                    </div>
                    <div className={inputStyles["styled-input-container"]} style={{width:"57%"}}>
                        <input
                            style={{width:"100%"}}
                            id="phone"
                            value={userData.phone}
                            onChange={handleChange}
                        ></input>
                        <label className={userData.phone && inputStyles['filled']}>
                            Phone Number
                        </label>
                    </div>
                </div>
                <div className="input-name" style={{color:"#5E5E5E",fontSize:"13px"}}>
                    Address Info
                </div>
                <div style={{position: "relative"}}>
                    <span className="floating-label">Address Type</span>
                    <select
                        className={inputStyles["styled-input-select"]}
                        id="type"
                        style={{width:"300px"}}
                        value={userData.address.type}
                        onChange={(e) => 
                            handleChange(e, "type", "address")
                        }
                    >
                        <option value="">Address Type</option>
                        {dropdowns.addressType.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="address1"
                        style={{width:"300px"}}
                        value={userData.address.address1}
                        onChange={(e)=>handleChange(e,null,"address")}
                    ></input>
                    <label className={userData.address.address1 && inputStyles['filled']}>
                        Street Address (Ave, St, Blvd, etc.)
                    </label>
                </div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="address2"
                        style={{width:"300px"}}
                        value={userData.address.address2}
                        onChange={(e)=>handleChange(e,null,"address")}
                    ></input>
                    <label className={userData.address.address2 && inputStyles['filled']}>
                        Apartment, Suite, etc
                    </label>
                </div>
                <div style={{display:"flex", flexDirection:"column", width: "300px"}}>
                    <div className="input-block" style={{width: "100%"}}>
                        <div style={{position: "relative", width: "49%"}}>
                            <span className={"floating-label"} style={{zIndex:"1"}}>Country</span>
                                <Select
                                    options={dropdowns.countries.map((country) => {
                                        return ({
                                            label: country.name,
                                            value: country.code
                                        })
                                    })}
                                    styles={{
                                        ...customStyles.popup,
                                        container: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                        }),
                                    }}
                                    value={displayCountry}
                                    placeholder='Country'
                                    isSearchable={true}
                                    onChange={handleCountry}
                                />
                        </div>
                        <div style={{position: "relative", width: "49%"}}>
                            <span className={"floating-label"} style={{zIndex:"1"}}>State/Province</span>
                                <Select
                                    options={
                                        displayCountry.value
                                            ? dropdowns.countries
                                                .find(country => country.code === displayCountry.value)
                                                ?.states.map(state => ({
                                                    label: state.name,
                                                    value: state.code
                                                })) || []
                                            : []
                                    }
                                    styles={{
                                        ...customStyles.popup,
                                        container: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                        }),
                                    }}
                                    value={displayState}
                                    placeholder='State'
                                    isSearchable={true}
                                    onChange={handleState}
                                />
                        </div>
                    </div>
                    <div className="input-block" style={{marginBottom:"0px", width: "100%"}}>
                        <div className={inputStyles["styled-input-container"]} style={{width:"49%"}}>
                            <input
                                type="text"
                                style={{width:"100%"}}
                                id="city"
                                value={userData.address.city}
                                onChange={(e)=>handleChange(e, "city", "address")}
                            ></input>
                            <label className={userData.address.city && inputStyles['filled']}>
                            City
                            </label>
                        </div>
                        <div className={inputStyles["styled-input-container"]} style={{width:"49%"}}>
                            <input
                                type="number"
                                style={{width:"100%"}}
                                id="zip"
                                value={userData.address.zip}
                                onChange={(e)=>handleChange(e, "zip", "address")}
                            ></input>
                            <label className={userData.address.zip && inputStyles['filled']}>
                            Postal Code
                            </label>
                        </div>
                    </div>
                </div>
                
                {role==="Patient" &&
                    <div style={{display: "flex", flexDirection:"column", rowGap:"10px"}}>
                        <div className="input-name" style={{color:"#5E5E5E",fontSize:"13px"}}>
                            Preferences
                        </div>
                        <div style={{position: "relative"}}>
                            <span className="floating-label">Date Format</span>
                            <select
                                className={inputStyles["styled-input-select"]}
                                id="dateFormat"
                                style={{width:"300px"}}
                                value={userData.preferences.dateFormat}
                                onChange={(e)=>handleChange(e, "dateFormat", "preferences")}
                            >
                                <option value="">Select Date Format</option>
                                {DropdownData.dateFormats.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="unit-types" style={{display: "flex", width: "330px", justifyContent:"space-between", marginBottom:"20px"}}>
                            Unit Type
                            <div>
                                <input
                                    id="unitType" 
                                    type="radio"
                                    value="Imperial"
                                    checked={unitType === 'Imperial'}
                                    onChange={handleUnitChange}
                                /> 
                                <span style={{paddingLeft: "5px"}}>Imperial (lb, F)</span>
                            </div>
                            <div>
                                <input
                                    id="unitType" 
                                    type="radio"
                                    value="Metric"
                                    checked={unitType === 'Metric'}
                                    onChange={handleUnitChange}
                                /> 
                                <span style={{paddingLeft: "5px"}}>Metric (kg, C)</span>
                            </div>
                        </div>
                    </div>
                }
                <span style={{paddingBottom:"20px"}}></span>
            </div>
    )

}

export default ActivatePersonalInfo;